export class TipologiaFase{
    id:number;
    fase:string;
    titolo:string;
    descrizione:string; 
    isEntrata:boolean;
}